import React, {Component, Fragment} from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';

import './App.scss';

import StartPage from '../containers/pages/StartPage';
import NotFound404Page from '../containers/pages/NotFound404Page';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

class App extends Component {


  componentDidMount() {

  }

  render() {
    return (
        <BrowserRouter>
            <Switch>
              <Route exact path="/" component={StartPage}/>
              <Route component={NotFound404Page}/>
            </Switch>
        </BrowserRouter>
    );
  }
}

export default App;